import {customElement, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {resolve} from "../../../../container";
import {SiteSearchBackend} from "./siteSearchBackend";
import {FilteredSearch} from "../filteredSearch";
import type {Maybe, Nullable} from "../../../../bootstrap/common/types";
import {EopSiteSearchTiles} from "./siteSearchTiles";

@customElement("eop-site-search")
export class EopSiteSearch extends FilteredSearch {

    @query("eop-site-search-tiles")
    private tiles: EopSiteSearchTiles;

    @query(".site-search-footer")
    protected footer: HTMLElement;

    public constructor(backend: SiteSearchBackend = resolve(SiteSearchBackend)) {
        super(true);
        this.searchFacade.registerBackend(backend);
    }

    public render(): TemplateResult {
        return html`
            <eop-viewport-spinner events="search,more"></eop-viewport-spinner>
            ${this.renderResultsLabel()}
            <eop-site-search-tiles class="tiles"></eop-site-search-tiles>
            ${this.renderSearchTags()}
            <div class="site-search-footer">
                ${this.renderMoreButton()}
            </div>`;
    }

    private renderSearchTags(): Nullable<TemplateResult> {
        if (this.searchFacade.totalCount() !== 0) {
            return null;
        }

        return html`
            <eop-search-tags .tags=${this.tags} .targetUrl=${this.targetUrl} class="initial"></eop-search-tags>`;
    }

    protected lastFocusable(): Maybe<HTMLElement> {
        return this.tiles.lastFocusable();
    }
}
